module.exports = __webpack_public_path__ + "img/customerLogo14.313efc98.png";